export default {"src":"/_next/static/media/herb.deb7d4fd.svg","height":500,"width":500,"blurWidth":0,"blurHeight":0};